// @TODO - Falta inserir o systemId e o productId no arquivo .env (será criado ainda pelo time de produto)

export const GLOBALIZATION_SYSTEM_ID =
  process.env.NEXT_PUBLIC_GLOBALIZATION_SYSTEM_ID;
export const GLOBALIZATION_BASE_API_URL =
  process.env.NEXT_PUBLIC_GLOBALIZATION_BASE_API_URL;
export const GLOBALIZATION_PRODUCT_ID =
  process.env.NEXT_PUBLIC_GLOBALIZATION_PRODUCT_ID;

// GET - Retorna termos e traduções para uma tag
export const GLOBALIZATION_GET_TERMS_AND_TRANSLATIONS_BY_TAG_ENDPOINT =
  'terms/translations/tags';

export const GLOBALIZATION_GET_CULTURES_ENDPOINT = 'cultures/all';
